export default __webpack_public_path__ + "static/media/doctor2.9a4bdc0e.jpg";